import { Box, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useT } from '../../i18n/useT';
import { AUTH_IMPRINT_URL, AUTH_PRIVACY_URL } from './authLegalUrls';
import { authScreen } from './authScreenStyles';

export default function AuthLegalFooter() {
  const t = useT();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2.5, pt: 3, mt: 1 }}>
      <Link
        component={RouterLink}
        to={AUTH_IMPRINT_URL}
        underline="hover"
        sx={{ color: authScreen.textDim, fontSize: '0.75rem', fontFamily: authScreen.font }}
      >
        {t('loginImprint')}
      </Link>
      <Link
        component={RouterLink}
        to={AUTH_PRIVACY_URL}
        underline="hover"
        sx={{ color: authScreen.textDim, fontSize: '0.75rem', fontFamily: authScreen.font }}
      >
        {t('loginPrivacyPolicy')}
      </Link>
    </Box>
  );
}
